import { useEffect, useRef } from "react";
import { Checkbox, Link } from "@heroui/react";
import {
	DECLARATION_ACCEPT_LABEL,
	DECLARATION_SECTIONS,
	DECLARATION_TERMS_ITEM,
	RENEWAL_CONTACT_CONSENT_TEXT,
} from "@shared/entities";

type Props = {
	accepted: boolean;
	onAcceptedChange: (value: boolean) => void;
	renewalContactConsent: boolean;
	onRenewalContactConsentChange: (value: boolean) => void;
	showError: boolean;
	/** Changes on every refused attempt; brings the checkbox into view. */
	errorAttempt: number;
};

/** "Before sending the request — please read and confirm". */
export function SubmissionDeclaration(props: Props) {
	const t = DECLARATION_TERMS_ITEM;
	const acceptRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (props.errorAttempt > 0) acceptRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
	}, [props.errorAttempt]);
	return (
		<div className="space-y-4 text-start" dir="rtl">
			<h3 className="text-lg font-semibold">לפני שליחת התיק — אנא קרא/י ואשר/י:</h3>
			<div className="sm:max-h-80 sm:overflow-y-auto rounded-lg border border-default-200 bg-default-50 p-4 space-y-4 text-sm leading-relaxed">
				{DECLARATION_SECTIONS.map((section) => (
					<div key={section.title}>
						<p className="font-semibold mb-1">{section.title}</p>
						<ul className="list-disc ps-5 space-y-1">
							{section.items.map((item) => (
								<li key={item}>{item}</li>
							))}
							{section === DECLARATION_SECTIONS[DECLARATION_SECTIONS.length - 1] && (
								<li>
									{t.before}
									<Link href="/policy/cana-terms" target="_blank" size="sm" underline="always">
										{t.terms}
									</Link>
									{t.between}
									<Link href="/policy/cana-privacy" target="_blank" size="sm" underline="always">
										{t.privacy}
									</Link>
									{t.after}
								</li>
							)}
						</ul>
					</div>
				))}
			</div>
			<div
				ref={acceptRef}
				className={`rounded-lg border-2 p-3 transition-colors ${
					props.showError ? "border-danger bg-danger-50" : "border-transparent"
				}`}
			>
				<Checkbox isSelected={props.accepted} onValueChange={props.onAcceptedChange} isInvalid={props.showError}>
					<span className="font-medium">{DECLARATION_ACCEPT_LABEL}</span>
				</Checkbox>
				{props.showError && (
					<p className="text-danger text-sm mt-1 font-medium">חובה לסמן את האישור — בלי זה לא ניתן לשלוח את הבקשה</p>
				)}
			</div>
			<div>
				<Checkbox isSelected={props.renewalContactConsent} onValueChange={props.onRenewalContactConsentChange}>
					<span className="text-sm">{RENEWAL_CONTACT_CONSENT_TEXT}</span>
				</Checkbox>
			</div>
		</div>
	);
}
